import React from 'react';
import { Link } from 'react-router-dom';

const TermsOfUsePage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-4xl mx-auto px-4 py-10 md:px-6 md:py-14">
        <div className="mb-8">
          <Link to="/" className="text-sm font-semibold text-blue-700 hover:text-blue-800">
            Voltar para a home
          </Link>
        </div>

        <div className="bg-white rounded-2xl border border-gray-200 shadow-sm p-6 md:p-10">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-3">
            Termos e Condições de Uso - Sinal Invest
          </h1>
          <p className="text-sm text-gray-500 mb-8">
            Última atualização: 04 de março de 2026
          </p>

          <div className="space-y-6 text-gray-700 leading-relaxed">
            <section>
              <p>
                Bem-vindo(a) ao Sinal Invest. Este documento estabelece as regras, diretrizes e condições
                aplicáveis ao uso da nossa plataforma web, painel de controle (dashboard) e integrações via
                Telegram (coletivamente denominados "Serviço" ou "Plataforma").
              </p>
              <p className="mt-3">
                Ao criar uma conta e utilizar o Sinal Invest, você concorda expressamente com estes Termos de
                Uso. Caso não concorde com qualquer condição aqui estabelecida, por favor, não utilize o nosso
                Serviço.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-2">1. O Serviço</h2>
              <p>
                O Sinal Invest é uma plataforma de Software as a Service (SaaS) que utiliza tecnologias de
                automação e Inteligência Artificial para monitorar, agregar e analisar notícias públicas referentes
                a empresas listadas na B3 (Bolsa de Valores Brasileira). O Serviço entrega resumos, análises de
                sentimento (positivo, negativo ou neutro) e alertas em tempo real ou em lotes, visando otimizar o
                tempo de leitura e pesquisa do usuário.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-2">
                2. Isenção de Responsabilidade Financeira e Limitações da IA (ATENÇÃO)
              </h2>
              <p className="mb-2">O usuário compreende e concorda expressamente que:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>
                  <strong>Não somos analistas:</strong> O Sinal Invest não é uma corretora, casa de análise ou
                  consultoria financeira. Não emitimos relatórios de análise de valores mobiliários e não somos
                  registrados na CVM (Comissão de Valores Mobiliários).
                </li>
                <li>
                  <strong>Ausência de Recomendação:</strong> Nenhuma informação, alerta de Telegram, análise de
                  impacto ou dado gerado pela plataforma constitui recomendação de compra, venda ou manutenção de
                  ativos financeiros.
                </li>
                <li>
                  <strong>Limitações Tecnológicas:</strong> As análises são geradas por modelos de Inteligência
                  Artificial baseados no processamento de linguagem natural sobre textos de terceiros (portais de
                  notícias). A IA está sujeita a interpretações equivocadas, imprecisões ou "alucinações"
                  algorítmicas.
                </li>
                <li>
                  <strong>Risco do Investidor:</strong> O usuário é o único e exclusivo responsável por suas
                  decisões de investimento. O Sinal Invest não se responsabiliza por quaisquer perdas, danos
                  financeiros, lucros cessantes ou prejuízos decorrentes do uso das informações fornecidas pela
                  plataforma.
                </li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-2">3. Cadastro e Conta de Usuário</h2>
              <p className="mb-2">
                Para acessar os recursos do Sinal Invest, você precisará criar uma conta. Você é responsável por:
              </p>
              <ul className="list-disc pl-6 space-y-1">
                <li>Fornecer informações verdadeiras e atualizadas.</li>
                <li>Manter a confidencialidade da sua senha e das credenciais de acesso.</li>
                <li>Restringir o acesso ao seu computador, smartphone ou conta do Telegram vinculada.</li>
              </ul>
              <p className="mt-3">
                O compartilhamento de contas com terceiros é estritamente proibido e pode resultar na suspensão
                imediata da assinatura sem aviso prévio.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-2">4. Planos, Pagamentos e Cancelamento</h2>
              <p className="mb-2">
                O Sinal Invest opera sob o modelo de assinatura com renovação automática (mensal, semestral ou
                anual, conforme escolhido no momento da contratação).
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>
                  <strong>Cobrança:</strong> Os pagamentos são processados por plataformas parceiras seguras Asaas.
                </li>
                <li>
                  <strong>Inadimplência:</strong> O não pagamento ou falha na cobrança do cartão de crédito
                  resultará na suspensão automática do envio de alertas e do acesso aos recursos premium do
                  dashboard.
                </li>
                <li>
                  <strong>Cancelamento:</strong> Você pode cancelar a renovação automática da sua assinatura a
                  qualquer momento através do painel de configurações. O acesso aos recursos continuará disponível
                  até o final do ciclo de faturamento já pago. Não oferecemos reembolsos proporcionais por meses
                  parcialmente utilizados.
                </li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-2">
                5. Propriedade Intelectual e Uso Aceitável
              </h2>
              <p className="mb-2">
                Todo o código-fonte, design, logotipos, algoritmos, fluxos de dados e infraestrutura do Sinal
                Invest são de propriedade exclusiva da plataforma. É estritamente proibido ao usuário:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>
                  Realizar engenharia reversa, descompilar ou tentar extrair o código-fonte do sistema.
                </li>
                <li>
                  Utilizar robôs, spiders, crawlers ou ferramentas de scraping para extrair dados em massa do
                  nosso dashboard.
                </li>
                <li>
                  Revender, licenciar ou redistribuir os alertas do Telegram e as análises geradas pela plataforma
                  para terceiros ou em grupos públicos/privados sem autorização comercial específica.
                </li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-2">6. Disponibilidade do Serviço</h2>
              <p>
                Nossa infraestrutura opera na nuvem e depende de serviços de terceiros (provedores de hospedagem,
                APIs de IA, portais de notícias e o aplicativo Telegram). Embora nos esforcemos para manter um
                uptime de 99%, o Serviço é fornecido "no estado em que se encontra" (as is). Não garantimos que a
                plataforma estará livre de interrupções temporárias, atrasos na entrega de mensagens ou
                indisponibilidades causadas por motivos de força maior.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-2">7. Modificações nos Termos</h2>
              <p>
                O Sinal Invest reserva-se o direito de modificar estes Termos de Uso a qualquer momento, para
                refletir alterações na lei, novas funcionalidades ou mudanças no modelo de negócios. Notificaremos
                os usuários ativos sobre alterações significativas via e-mail ou aviso no painel.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-2">8. Foro e Legislação Aplicável</h2>
              <p>
                Estes Termos serão regidos e interpretados de acordo com as leis da República Federativa do
                Brasil, em especial o Marco Civil da Internet e a Lei Geral de Proteção de Dados (LGPD). Fica
                eleito o foro da Comarca de Manaus, Estado do Amazonas, para dirimir quaisquer controvérsias
                decorrentes da utilização da plataforma, com renúncia expressa a qualquer outro, por mais
                privilegiado que seja.
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsOfUsePage;

